export const GENERATIONS_PER_SITE = 10;
export const FREE_SUBSCRIPTION_ID = "YZEDxThrbbT0VJKd6dHn";
